import {ListTableDataSourceFragment} from "@/shared/ListTableDataSourceFragment";
import {
  LABELER_REVIEW_STATUS_KTS,
  LabelerActivityLog,
  LabelerActivityLogs,
  ResourceData
} from "@/fyneai-shared/types";
import {TableDataContainer, TableDataRow} from "@/shared/TableDataContainer";
import {TableDataSourceFragmentProps} from "@/shared/TableDataSourceFragment";
import React from "react";
import {TableData} from "@/shared/tabledata";
import {PageFragment, PageFragmentStyleFlags} from "../../shared/PageFragment";
import {DateUtil, FORMAT_SHOW_TIME} from "../../shared/date_util";

class LabelerActivityLogRow implements TableDataRow {

  @TableData({name: "Dataset", cellSize: "large"})
  datasetId: string;

  @TableData({name: "Task", cellSize: "large"})
  taskId: string;

  @TableData({name: "Submitted", cellSize: "large"})
  submittedAt: string;

  @TableData({name: "Status", cellSize: "medium"})
  reviewStatus: string;

  @TableData({name: "Comments"})
  comments: string;
}

export class ActivityLogsFragment extends ListTableDataSourceFragment<LabelerActivityLog, LabelerActivityLogRow, LabelerActivityLogs, TableDataSourceFragmentProps> {

  constructor(props: TableDataSourceFragmentProps, context: any) {
    super(props, context, new LabelerActivityLogs(ResourceData.projectId()));
  }

  protected styleFlags(): number | PageFragmentStyleFlags {
    return PageFragment.STYLE_TOOLBAR_TYPE_FLAG;
  }

  protected getTitle(): string | null | undefined {
    return "Activity Logs";
  }

  protected getToolbar(toolbarModeId: string | null): React.ReactElement {
    return this.renderToolbarButtonsInToolbarContainerEx([]);
  }

  applyTableDataToRow(data: LabelerActivityLog, row: LabelerActivityLogRow): void {
    row.datasetId = data.datasetId;
    row.taskId = data.taskId;
    row.submittedAt = DateUtil.formatDateTime(data.submittedAt, FORMAT_SHOW_TIME);
    row.reviewStatus = LABELER_REVIEW_STATUS_KTS.findText(data.reviewStatus);
    row.comments = data.comments;
  }

  createTableDataRow(): LabelerActivityLogRow {
    return new LabelerActivityLogRow();
  }

  onTableCellChanged(data: LabelerActivityLog, cellId: string, value: any): void {
  }

  onTableDataSelected(data: LabelerActivityLog): void {
  }

  renderContent(): React.ReactElement {
    return <TableDataContainer
      path={this.props.path}
      data={this.loader.getListItems()}
      source={this}/>;
  }
}
